<template>
  <div>
    <chart-header header-name="averageResponseTime" />

    <div>
      <clip-loader v-if="loading" />
      <h1
        v-if="!loading && responseTimes && responseTimes.avgResponseTime"
        class="p-3"
      >
        <span v-if="formatTime(responseTimes.avgResponseTime).days"
          >{{ formatTime(responseTimes.avgResponseTime).days }}
          {{ trans("statistics.days") }}</span
        >
        <span v-if="formatTime(responseTimes.avgResponseTime).hours"
          >{{ formatTime(responseTimes.avgResponseTime).hours }}
          {{ trans("statistics.hours") }}</span
        >
      </h1>
      <h1
        v-if="!loading && responseTimes && !responseTimes.avgResponseTime"
        class="text-center"
      >
        <span v-if="responseTimes.numberOfAnsweredExaminations > 0">{{
          responseTimes.avgResponseTime
        }}</span>
        <span v-else>-</span>
      </h1>
    </div>
  </div>
</template>

<script>
import ChartHeader from "./StatisticsUtils/ChartHeader.vue";
export default {
  components: {
    ChartHeader,
  },
  props: {
    responseTimes: {
      avgResponseTime: Number,
      numberOfAnsweredExaminations: Number,
      numberOfUnansweredExaminations: Number,
    },
    loading: Boolean,
  },
  methods: {
    formatTime: function (responseTime) {
      if (responseTime < 48) {
        // show hours
        return { hours: Math.ceil(responseTime) };
      } else {
        //show days
        const days = Math.ceil(moment.duration(responseTime, "hours").asDays());
        return { days };
      }
    },
  },
};
</script>
